import React__default from 'react';
import { I as Icon } from './index-8671f6be.js';
import { u as useTranslations } from './index-ef9bdc70.js';

var styles = {"loading":"tliWyii"};

const Loading = ({ className, theme, hideText }) => {
    const { t } = useTranslations();
    return (React__default.createElement("div", { className: `${styles.loading} ${className}` },
        React__default.createElement(Icon.Spinner, { isMarryBaby: theme === 'marryBaby' }),
        !hideText && t('loading')));
};

export { Loading as L };
